/* eslint-disable no-shadow, no-param-reassign */
import { make } from 'vuex-pathify';
import { find } from 'lodash';

//words included in route names to use for identifying in what type of route we are
//DEV NOTE: 'show' currently not supported because we need enhanced logic for child/tab routes
const ROUTE_NAME_TYPE_WORDS = ['index', 'new', 'edit'];

const state = {
  pwaInstallEvent: undefined,
  // REFACTOR: The keys below are exclusively coupled to global control of TheAppCardWrapper styling.
  maxBreakpoint: undefined,
  isFluid: false,

  // ROUTING variables
  currentRoute: undefined,
  previousRoute: undefined,

  // Keep only attachment-related form state
  attachmentTokens: undefined,
  activeUploads: [],
};

const getters = {
  pwaInstallable: state => {
    const onMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    return onMobile && state.pwaInstallEvent !== undefined;
  },
  //ROUTING VARIABLES
  previousRoute: state => {
    return state.previousRoute;
  },
  previousRouteName: state => {
    return state.previousRoute?.name;
  },
  currentRoute: state => {
    return state.currentRoute;
  },
  currentRouteName: state => {
    return state.currentRoute?.name;
  },
  currentRouteResource: state => {
    return (
      state.currentRoute?.meta?.resource ||
      state.currentRoute.matched.filter(x => x.meta?.resource).at(-1)?.meta
        ?.resource
    );
  },
  currentRouteAction: state => {
    return state.currentRoute?.meta?.action;
  },
  currentRouteType: (_state, getters) => {
    let lowerCaseCurrentRouteType = getters.currentRoute?.meta?.action || '';
    if (lowerCaseCurrentRouteType === undefined) return;
    return find(ROUTE_NAME_TYPE_WORDS, word =>
      lowerCaseCurrentRouteType.includes(word.toLowerCase())
    );
  },
  isCurrentRouteAType: (_state, getters) => type => {
    return getters.currentRouteType == type;
  },
  isCurrentRouteAForm: (_state, getters) => {
    return (
      getters.isCurrentRouteAType('new') || getters.isCurrentRouteAType('edit')
    );
  },
  attachmentTokens: state => {
    return state.attachmentTokens;
  },
  activeUploads: state => {
    return state.activeUploads;
  },
};

const mutations = {
  ...make.mutations(state),
  //ROUTE mutations
  setPreviousRoute(state, route) {
    state.previousRoute = route;
  },
  setCurrentRoute(state, route) {
    state.currentRoute = route;
  },
  setAttachmentTokens(state, tokens) {
    state.attachmentTokens = tokens;
  },
  addActiveUpload(state, val) {
    state.activeUploads.push(val);
  },
  removeActiveUpload(state, val) {
    state.activeUploads = state.activeUploads.filter(
      upload => upload.key != val?.key
    );
  },
};

const actions = {
  approvePWA({ commit, state, dispatch }) {
    const { pwaInstallEvent } = state;

    // For testing purposes only
    if (typeof pwaInstallEvent === 'string') {
      dispatch('denyPWA');
      return;
    }
    // end testing

    if (pwaInstallEvent != undefined) {
      pwaInstallEvent.prompt();
      pwaInstallEvent.userChoice.then(result => {
        if (result.outcome === 'accepted') {
          commit('pwaInstallEvent', undefined);
        }
      });
    }
  },
  denyPWA({ commit }) {
    commit('pwaInstallEvent', undefined);
  },
  setMaxBreakpoint({ commit, state }, v) {
    if (state.maxBreakpoint === v) {
      return;
    }
    if (Object.keys(this.$app.$vuetify?.breakpoint.thresholds).includes(v)) {
      commit('maxBreakpoint', v);
    } else {
      commit('maxBreakpoint', undefined);
    }
  },
  //ROUTE actions
  setCurrentRoute({ commit }, route) {
    if (route === undefined || route.name === undefined) return;
    commit('setCurrentRoute', route);
  },
  setPreviousRoute({ commit }, route) {
    commit('setPreviousRoute', route);
  },
  setAttachmentTokens({ commit }, tokens) {
    commit('setAttachmentTokens', tokens);
  },
  addActiveUpload({ commit }, val) {
    commit('addActiveUpload', val);
  },
  removeActiveUpload({ commit }, val) {
    commit('removeActiveUpload', val);
  },
};

export default {
  namespaced: true,
  state: () => state,
  getters,
  mutations,
  actions,
};
